import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import PhoneInput from 'components/common/PhoneInput';
import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

function AddPatient({
    isOpen,
    onClose,
    onConfirm,
    appointmentId,
    item
}) {

    const methods = useForm();
    const { control, formState: { errors }, handleSubmit ,setValue} = methods;
    const [loader, setLoader] = useState(false);
    const [loaderHangup, setLoaderHangup] = useState(false);
   
    useEffect(() => {
        setValue('patient_phone', item?.appointment_details?.patient_phone || '')
    }, [isOpen])

    const onHangUp = () =>{
        setLoaderHangup(true)
        onConfirm({}, "hang-up-call", () => {
            setLoaderHangup(false);
        })

    }
    
    return (
        <>
            <Modal isOpen={isOpen} toggle={onClose} centered className="modal-medium">
                <form action="" onSubmit={
                    handleSubmit((data) => {
                        setLoader(true); onConfirm(data, "add-patient", () => {
                            setLoader(false);
                        })})}>
                <ModalHeader className='header_modal align-items-center'>
                    <h5 className="modal-title_u">Add Patient</h5>
                </ModalHeader>
                <ModalBody className='modal_form_body'>
                    <div className='step_cards step_1'>
                        <h2>Appointment ID: {appointmentId}</h2>
                        <div className="row-primary text-nowrap">
                            <h2>Patient Phone Number <span style={{ color: 'red' }}>*</span></h2>
                            <div className="w-100">
                                <Controller
                                    name="patient_phone"
                                    rules={{
                                        required: "Please enter phone number",
                                    }}
                                    control={control}
                                    render={({ field }) => <PhoneInput className="input-in type_inp" type="tel" name='patient_phone' placeholder='Patient phone number' required {...field} />}
                                />
                                {
                                    errors?.patient_phone?.message &&
                                    <div style={{ marginBottom: 10 }}>
                                        <ErrorMessage text={errors?.patient_phone?.message} />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                {/* <SubmitButton 
                buttonType="button" btnText="Hang Up Call" 
                loader={loaderHangup} className="green" disabled={loader}
                handleSubmit={onHangUp}
                 /> */}
                    <SubmitButton buttonType="submit" btnText="Add patient" loader={loader} disabled={loaderHangup} />
                    <button className="table_delete" type='button' onClick={onClose}>Cancel</button>
                </ModalFooter>
            </form>
        </Modal >
        </>
    );
}

export default AddPatient;